import { addCarrierSettings } from './addCarrierSettings';
import { editCarrierSettings } from './editCarrierSettings';
import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';

export const workflows: WorkflowOptions[] = [
  addCarrierSettings,
  editCarrierSettings,
  ...Object.values(generateAssetStatusWorkflow('carrierSettings')),
];

export default workflows;
